import React, { useEffect, useState } from "react";
import CloseIcon from "../../../../../assets/images/icons/CloseIcon";
import DragIcon from "../../../../../assets/images/icons/DragIcon";
import FullScreenIcon from "../../../../../assets/images/icons/FullScreenIcon";
import { MiniPlayerStyle } from "./MiniPlayer.style";

const MiniPlayer = ({
  section,
  backToFullScreen,
  setMiniPlayerSection,
}: any) => {
  const [isOnKeyPress, setOnKeyPress] = useState(false);
  const [clientPosition, setClientPosition] = useState<any>({
    right: "25px",
    bottom: "0",
  });

  const move = (event: any) => {
    setClientPosition({
      top: event.clientY - 25 - 225 + "px",
      left: event.clientX - 25 + "px",
    });
  };

  useEffect(() => {
    isOnKeyPress && document.addEventListener("mousemove", move);
    return () => {
      document.removeEventListener("mousemove", move);
    };
  });

  return (
    <MiniPlayerStyle
      style={{
        position: "fixed",
        ...clientPosition,
        zIndex: 1000,
      }}
    >
      <div className="video">
        <iframe
          width="100%"
          height="315"
          src={section.url}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="bottom">
        {/* <span
          className="drag"
          onMouseUp={() => setOnKeyPress(false)}
          onMouseDown={() => setOnKeyPress(true)}
        >
          <DragIcon />
        </span> */}
        <h6 className="title">{section.name}</h6>
        <div className="right">
          <span className="fullscreen" onClick={backToFullScreen}>
            <FullScreenIcon />
          </span>
          <span className="close" onClick={() => setMiniPlayerSection(null)}>
            <CloseIcon />
          </span>
        </div>
      </div>
    </MiniPlayerStyle>
  );
};

export default MiniPlayer;
